// @generated
import { PapiUser } from '@wix/da-papi-types';

export const users: PapiUser[] = [
  {
    userId: 3,
    useridUuid: '178e6afa-0f9b-4ef0-bb15-47dadfa0e470',
    username: 'chris',
    usericon: 'https://a.deviantart.net/avatars/c/h/chris.jpg?3',
    type: 'admin',
    isNewDeviant: true,
  },
  {
    userId: 30306810,
    useridUuid: 'f4ac8243-286f-454f-936f-825e03f77696',
    username: 'superbearpower',
    usericon: 'https://a.deviantart.net/avatars/s/u/superbearpower.gif?3',
    type: 'hell-beta',
    isNewDeviant: true,
  },
  {
    userId: 806309,
    useridUuid: '8b02f868-6f44-4074-af1c-af28adee15f5',
    username: 'Merf',
    usericon: 'https://a.deviantart.net/avatars/m/e/merf.gif',
    type: 'hell',
    isNewDeviant: true,
  },
  {
    userId: 1730044,
    useridUuid: '46e000dd-c61d-4268-b5b1-c4074c073de9',
    username: 'wwwwwwwwwwwwwwwwwwww',
    usericon: 'https://a.deviantart.net/avatars/default.gif',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 11870562,
    useridUuid: 'b45812ba-2d41-4b3e-bd37-175333ce475e',
    username: 'wlop',
    usericon: 'https://a.deviantart.net/avatars/w/l/wlop.jpg?7',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 2321415,
    useridUuid: '6057945b-a390-4876-97db-5e51a65b29e7',
    username: 'sakimichan',
    usericon: 'https://a.deviantart.net/avatars/s/a/sakimichan.jpg?4',
    type: 'senior',
    isNewDeviant: true,
  },
  {
    userId: 20801402,
    useridUuid: '911b2eab-54a3-46e0-b817-2ee1f5ab09ed',
    username: 'JRCoffronIII',
    usericon: 'https://a.deviantart.net/avatars/j/r/jrcoffroniii.jpg?1',
    type: 'beta',
    isNewDeviant: true,
  },
  {
    userId: 7644231,
    useridUuid: 'dcecb105-65f6-4092-9f89-ed0b1328e684',
    username: 'overdebated',
    usericon: 'https://a.deviantart.net/avatars/o/v/overdebated.gif?15',
    type: 'volunteer',
    isNewDeviant: true,
  },
  {
    userId: 30817266,
    useridUuid: '01b84681-d289-42f9-b7c9-1ed49e565703',
    username: 'outgoingcoyote',
    usericon: 'https://a.deviantart.net/avatars/o/u/outgoingcoyote.png?4',
    type: 'admin',
    isNewDeviant: true,
  },
  {
    userId: 1739297,
    useridUuid: '9ad8fbc8-aee8-4e92-a04b-6abf7a036a51',
    username: 'ArtBIT',
    usericon: 'https://a.deviantart.net/avatars/a/r/artbit.gif',
    type: 'admin',
    isNewDeviant: true,
  },
  {
    userId: 626741,
    useridUuid: 'a7cad72d-a394-4ed4-a4ca-249e36498793',
    username: 'petralfire',
    usericon: 'https://a.deviantart.net/avatars/p/e/petralfire.jpg?4',
    type: 'admin',
    isNewDeviant: true,
  },
  {
    userId: 42178215,
    useridUuid: '06093f60-25f4-489e-b4c2-b3ec3d2a6bf1',
    username: 'thedatadoctor',
    usericon: 'https://a.deviantart.net/avatars/default.gif',
    type: 'admin',
    isNewDeviant: true,
  },
  {
    userId: 42171111,
    useridUuid: 'ef745bfc-d2ca-4b66-901b-ac3423deaf44',
    username: 'notroot',
    usericon: 'https://a.deviantart.net/avatars/n/o/notroot.jpg',
    type: 'admin',
    isNewDeviant: true,
  },
  {
    userId: 41771750,
    useridUuid: 'a2f3c2bf-cc4a-4280-b699-df89aaf0edc1',
    username: 'Dzydar',
    usericon: 'https://a.deviantart.net/avatars/d/z/dzydar.jpg?1',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 35545143,
    useridUuid: '0affc74e-9212-4c04-96c5-d8c6f1e7fb71',
    username: 'Amethyst-Ocean',
    usericon: 'https://a.deviantart.net/avatars/a/m/amethyst-ocean.png?7',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 2303202,
    useridUuid: '349bdeb2-f381-4900-9146-dcca4bc3dbea',
    username: 'Abiogenisis',
    usericon: 'https://a.deviantart.net/avatars/a/b/abiogenisis.jpg?1',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 24920345,
    useridUuid: '6cbad1f2-133c-4349-a015-5288724be11a',
    username: 'doubleWbrothers',
    usericon: 'https://a.deviantart.net/avatars/d/o/doublewbrothers.jpg?2',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 13074561,
    useridUuid: '4cf3dd34-cd08-40c9-9e79-78e821929239',
    username: 'Kay-Ra',
    usericon: 'https://a.deviantart.net/avatars/k/a/kay-ra.png',
    type: 'beta',
    isNewDeviant: true,
  },
  {
    userId: 19532739,
    useridUuid: 'f49b7fed-bb8c-4ce3-b207-f7ea09481dc9',
    username: 'CGCookie',
    usericon: 'https://a.deviantart.net/avatars/c/g/cgcookie.png?5',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 3693223,
    useridUuid: '6f131d22-7974-4793-9db3-2160376b5c72',
    username: 'Its-Raining-Neon',
    usericon: 'https://a.deviantart.net/avatars/i/t/its-raining-neon.jpg?6',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 20297120,
    useridUuid: '5f04ced4-1e30-4156-8323-91b4377c8736',
    username: 'NostalgicChills',
    usericon: 'https://a.deviantart.net/avatars/n/o/nostalgicchills.gif?3',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 8438009,
    useridUuid: 'ccd2b922-a589-47cc-8988-2fb7e2164741',
    username: 'VityaR83',
    usericon: 'https://a.deviantart.net/avatars/v/i/vityar83.png?1',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 1193695,
    useridUuid: 'fd392d69-a1f3-4639-af21-10de6a84e875',
    username: 'mauroz',
    usericon: 'https://a.deviantart.net/avatars/m/a/mauroz.jpg?1',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 2888745,
    useridUuid: '06d4d763-9fb0-4ffb-a5af-3e7d2008c376',
    username: 'Dyemelikeasunset',
    usericon: 'https://a.deviantart.net/avatars/d/y/dyemelikeasunset.gif?9',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 4743209,
    useridUuid: 'a89173c8-93ce-4a91-a0c9-1e04cd1e5fdc',
    username: 'CometComics',
    usericon: 'https://a.deviantart.net/avatars/c/o/cometcomics.png?9',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 4924922,
    useridUuid: '41e1b92f-a828-421d-abea-273706d40b1e',
    username: 'Pretty-As-A-Picture',
    usericon: 'https://a.deviantart.net/avatars/p/r/pretty-as-a-picture.gif?1',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 37670292,
    useridUuid: '896d5e56-3cdd-4907-96f4-41139f1ebfd0',
    username: 'GraWolfQuinn',
    usericon: 'https://a.deviantart.net/avatars/g/r/grawolfquinn.gif?6',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 4909782,
    useridUuid: '8b149646-9d3e-4347-8f4d-cfee17b17cc6',
    username: 'SpainFischer',
    usericon: 'https://a.deviantart.net/avatars/s/p/spainfischer.gif?2',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 1152341,
    useridUuid: 'c11af197-8673-4440-9749-b83bc922a106',
    username: 'eddsworld',
    usericon: 'https://a.deviantart.net/avatars/e/d/eddsworld.gif?2',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 15989743,
    useridUuid: '1f156103-0873-47d9-a3c8-d64b693702cb',
    username: 'Redsaph',
    usericon: 'https://a.deviantart.net/avatars/r/e/redsaph.png?10',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 6489410,
    useridUuid: '7e4d1087-8db8-48ae-8e80-6a37283e3db8',
    username: 'MakeupSiren',
    usericon: 'https://a.deviantart.net/avatars/m/a/makeupsiren.jpg?3',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 15546108,
    useridUuid: 'fc684907-67f1-4f66-8112-30a2f59c5386',
    username: 'usagiyuu',
    usericon: 'https://a.deviantart.net/avatars/u/s/usagiyuu.jpg?3',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 6328162,
    useridUuid: 'eb76932e-29bb-46ec-a4b8-1ea57c74092f',
    username: 'LeighKellogg',
    usericon: 'https://a.deviantart.net/avatars/l/e/leighkellogg.jpg?2',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 20043455,
    useridUuid: '2d04bb6b-4e46-4236-bfbb-aeba05f80f79',
    username: 'ERA-7',
    usericon: 'https://a.deviantart.net/avatars/e/r/era-7.gif?15',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 463431,
    useridUuid: 'b9fd9b31-5270-432d-97ef-039cf5e2c778',
    username: 'zarla',
    usericon: 'https://a.deviantart.net/avatars/z/a/zarla.gif',
    type: 'premium',
    isNewDeviant: true,
  },
  {
    userId: 20434502,
    useridUuid: 'aa426180-aa3a-455a-8504-7aeb3e056062',
    username: 'Eumenidi',
    usericon: 'https://a.deviantart.net/avatars/e/u/eumenidi.gif?7',
    type: 'regular',
    isNewDeviant: true,
  },
  {
    userId: 31609331,
    useridUuid: '56f2ed45-fa74-425e-a056-847abcd6c360',
    username: 'Sleepykinq',
    usericon: 'https://a.deviantart.net/avatars/s/l/sleepykinq.png?14',
    type: 'beta',
    isNewDeviant: true,
  },
];

export const under18User: PapiUser = {
  ...users[0],
  userId: 3333333,
  username: 'youngchris',
  type: 'regular',
  // need to override autobob1's dob from ../sessionLoggedIn
  // because it's the only dob in most createSampleStores
  dob: `${new Date().getFullYear() - 17}-01-01`,
} as any;
